var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({staticClass:"live-position font-weight-bold",class:[
        _vm.color,
        { 'label-left': _vm.left },
        _vm.text === 'Live' ? (_vm.domainUrl ? '' : 'super-live-position') : ''
    ],attrs:{"color":_vm.text === 'Live' ? (_vm.domainUrl ? 'white--text' : 'superBlue') : '',"dark":"","x-small":"","label":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }